import { useContext } from "react";
import { SidePanelContext } from "contexts/side-panel/side-panel-provider";

export const useSidePanel = () => useContext(SidePanelContext);
